import columns from '../../react-table/helpers/columns';
import TableDefinitions from '../../../common/TableDefinitions';

export function getYearlyThresholdPage(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/yearly-thresholds',
    tableId: TableDefinitions.YEARLY_THRESHOLDS_PAGE.id,
    text: 'View BOH Thresholds',
  } : {};
}

export function getImpcEditPage(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/impc-edit',
    tableId: TableDefinitions.YEARLY_THRESHOLDS_PAGE.id,
    text: 'Edit IMPC',
  } : {};
}

export default (data, userType) => {
  const {
    FilteredTextColumn,
    FilteredBooleanColumn,
    EditButtonColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Operator', 'operatorCode'),
        new FilteredTextColumn('IMPC', 'impcCode'),
        new FilteredBooleanColumn('Central entry point', 'centralEntryPoint'),
        new NavigationColumn(new EditButtonColumn('Edit action', 'impcCode').withShow(userType.includes('IPC')), getImpcEditPage),
        new NavigationColumn(new EditButtonColumn('View action', 'operatorCode'), getYearlyThresholdPage),
      ],
    },
  ];
};
